export default "__VITE_ASSET__CqCeEmmh__"